var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/FolderGrouping.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FolderGrouping = ({
  color = '#4C5ECF',
  ...other
}) => /*#__PURE__*/_jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: [/*#__PURE__*/_jsx("rect", {
    opacity: "0.1",
    width: "24",
    height: "24",
    rx: "4",
    fill: "#2235AA"
  }), /*#__PURE__*/_jsx("path", {
    d: "M10.4425 6.4425C10.1575 6.1575 9.775 6 9.3775 6H5.5C4.675 6 4.0075 6.675 4.0075 7.5L4 16.5C4 17.325 4.675 18 5.5 18H18.5C19.325 18 20 17.325 20 16.5V9C20 8.175 19.325 7.5 18.5 7.5H11.5L10.4425 6.4425Z",
    fill: color
  }), /*#__PURE__*/_jsx("path", {
    d: "M12.6097 15.2463C12.2486 15.5271 11.743 15.5271 11.3819 15.2464L9.17943 13.534C9.02977 13.4177 8.82024 13.4177 8.67061 13.5341V13.5341C8.45728 13.7 8.45728 14.0224 8.67061 14.1883L11.3861 16.3004C11.7472 16.5812 12.2528 16.5812 12.6139 16.3004L15.3268 14.1903C15.5415 14.0233 15.5417 13.6989 15.3271 13.5317V13.5317C15.1764 13.4143 14.9652 13.4142 14.8144 13.5315L12.6097 15.2463ZM11.3858 14.1878C11.747 14.4687 12.2528 14.4685 12.6139 14.1874L15.0667 12.2779V12.2779C15.413 12.0097 15.4135 11.487 15.0678 11.2181L12.6139 9.30954C12.2528 9.02868 11.7472 9.02868 11.3861 9.30954L8.92962 11.2201C8.5848 11.4883 8.58458 12.0094 8.92917 12.2779V12.2779L11.3858 14.1878Z",
    fill: "white"
  })]
});